import { UserInformationResponse } from '@/types/service-response'
import {formatFloatPrice} from '@/services/formatter'

export class CurrentUser {
  private constructor (
    readonly id: number,
    readonly debtor: boolean,
    readonly givenName: string,
    readonly familyName: string,
    readonly qrCode: string,
    readonly isBoarder: boolean,
    readonly isStaff: boolean,
    readonly staffRoleList: any,
    readonly boarderList: any,
    readonly loginName: string,
    readonly tenant:any,
    readonly phoneNumbers: string[],
    readonly currentCreditBalance: number
  ) {}

  get fullName (): string {
    return `${this.givenName} ${this.familyName}`
  }

  get getBoarders (): any {
    return this.boarderList
  }

  get getBoarder (): any {
    return this.boarderList.length > 0 ?  this.boarderList[0] : null
  }

  get getBoarderQRCode (): any {
    return this.boarderList.length > 0 ?  this.boarderList[0].qrCodeValue : null
  }

  get formattedCurrentCreditBalance(): string {
    return formatFloatPrice(this.currentCreditBalance)
  }

  static createFromUserInformationResponse (responseData: UserInformationResponse): CurrentUser {
    return new CurrentUser(
      responseData.id,
      responseData.debtor,
      responseData.givenName,
      responseData.familyName,
      responseData.qrCode,
      responseData.isBoarder,
      responseData.isStaff,
      responseData.staffRoleList,
      responseData.boarderList,
      responseData.loginName,
      responseData.tenant,
      responseData.phoneNumbers,
      responseData.currentCreditBalance
    )
  }
}
